<template>
  <div>
    <div :id="mapId" class="map-canvas"></div>
  </div>
</template>

<script>
import initMapMixin from '../../../mixins/initMapMixin';

export default {
  mixins: [initMapMixin],
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },

    title: {
      type: String,
      default: 'Sin Nombre',
    },

    latitude: {
      type: [String, Number],
      default: null,
    },

    longitude: {
      type: [String, Number],
      default: null,
    },
  },

  methods: {
    mapLoaded() {
      this.addMarker();
    },

    addMarker() {
      let marker = new this.google.maps.Marker({
        position: this.location,
        draggable: true,
        map: this.map,
        animation: this.google.maps.Animation.DROP,
        title: this.title,
        info: this.info,
      });

      this.addClickListener(marker);
      this.addDraggableListener(marker);
    },

    addDraggableListener(marker) {
      const vm = this;
      this.google.maps.event.addListener(marker, 'dragend', (ev) => {
        vm.setLatLng(ev.latLng);

        this.geocoder.geocode({ location: ev.latLng }, (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK) {
            marker.info = results[0];
          }
        });
      });
    },

    addClickListener(marker) {
      const vm = this;
      let lastInfoWindow = null;
      this.google.maps.event.addListener(marker, 'click', () => {
        let infoWindow = new this.google.maps.InfoWindow({
          content: vm.infoWindowTemplate(this.entity, marker),
        });

        if (lastInfoWindow) {
          lastInfoWindow.close();
        }

        infoWindow.open(this.map, marker);
        lastInfoWindow = infoWindow;
      });
    },

    setLatLng(latLng) {
      this.$emit('update:latitude', latLng.lat());
      this.$emit('update:longitude', latLng.lng());
    },
  },
};
</script>

<style scoped>
.map-canvas {
  height: 100vh;
}
</style>
